/** Shopify CDN: Minification failed

Line 25:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 26:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 27:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 28:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 29:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 31:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 33:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 35:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 37:2 Transforming let to the configured target environment ("es5") is not supported yet
Line 38:2 Transforming let to the configured target environment ("es5") is not supported yet
... and 140 more hidden warnings

**/
/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(async function () {
  const jsonElement = $("#custom-product-configurator-json");
  const fullData = JSON.parse(jsonElement.html());
  const jsonMetafieldsElement = $("#custom-product-configurator-metafields-json");
  const productMetafields = JSON.parse(jsonMetafieldsElement.html());

  const apiEndpoint = "https://k42xhfp7p7.execute-api.us-west-2.amazonaws.com/Prod";

  const configuratorContainer = $("#custom-configurator-container");

  const productCode = configuratorContainer.attr("data-product-code");

  let fullWeightData = await $.get(window.theme.assets.custom_product_weight).promise();
  let fullOptionsData = await $.get(window.theme.assets.custom_product_options).promise();
  fullWeightData = fullWeightData.data;

  let weightData;
  let optionsData;

  fullWeightData.forEach(function (element) {
    if (element.Line == productCode) {
      weightData = element;
    }
  });

  fullOptionsData.forEach(function (element) {
    if (element.Code == productCode) {
      optionsData = element;
    }
  });

  const lowercaseKeys = (obj) =>
    Object.keys(obj).reduce((acc, key) => {
      acc[key.toLowerCase()] = obj[key];
      return acc;
    }, {});

  const optionsDataLowerKeys = lowercaseKeys(optionsData);
  const weightOptionsLowerKeys = lowercaseKeys(weightData);

  const widthSelect = $("#select-width-id");
  const lengthSelect = $("#select-length-id");

  let minLength = 14;
  let maxLength = 275;
  let lengthValue = 14;

  let minWidth = 25;
  let maxWidth = 200;
  let maxWidthForPleat = 200;
  let widthValue = 1;

  const manageAvailability = () => {
    const headersOptions = $("#custom-header-selector").children();
    const liningOptions = $("#custom-lining-selector").children();
    const allOptions = $(".custom-managable-options");

    allOptions.each(function (_, el) {
      const headerName = $(el).attr("data-image-select-item").toLowerCase();
      if (optionsDataLowerKeys[headerName] == "FALSE") {
        $(el).hide();
        $(el).attr("data-is-active", "false");
      } else {
        $(el).attr("data-is-active", "true");
      }
    });

    for (let index = 0; index < headersOptions.length; index++) {
      const element = headersOptions[index];
      if ($(element).attr("data-is-active") == "true") {
        const valueSelected = $(element).attr("data-image-select-item");
        const priceSelected = $(element).attr("data-image-select-item-price");
        const panelType = $(element).attr("data-image-panel-type");
        const fabricationCost = $(element).attr("data-image-fabrication-cost");
        const headerValueText = $('.custom-configurator-header');

        $(element).parent().attr("data-image-select-value", valueSelected);
        $(element).parent().attr("data-image-select-value-price", priceSelected);
        $(element).parent().attr("data-image-panel-type", panelType);
        if (panelType == "Flat") {
          createSelectOptions(widthOptions, "select-width-id");
        } else if (panelType == "Pleat") {
          createSelectOptions(widthOptionsForPleat, "select-width-id");
        }
        widthValue = minWidth;
        $(element).parent().attr("data-image-fabrication-cost", fabricationCost);
        $(element).parent().prev().children(".custom-configurator-option-title-value").html(valueSelected);
        $(element).addClass("custom-configurator-image-select-item-active");
        headerValueText.html(valueSelected);
        break;
      }
    }

    for (let index = 0; index < liningOptions.length; index++) {
      const element = liningOptions[index];
      if ($(element).attr("data-is-active") == "true") {
        const valueSelected = $(element).attr("data-image-select-item");
        const priceSelected = $(element).attr("data-image-select-item-price");
        const liningValueText = $('.custom-configurator-lining');

        $(element).parent().attr("data-image-select-value", valueSelected);
        $(element).parent().attr("data-image-select-value-price", priceSelected);
        $(element).parent().prev().children(".custom-configurator-option-title-value").html(valueSelected);
        $(element).addClass("custom-configurator-image-select-item-active");
        liningValueText.html(valueSelected);
        break;
      }
    }
  };

  const getWeightPriceValue = (lineOption) => {
    console.log(weightOptionsLowerKeys[lineOption])
    return weightOptionsLowerKeys[lineOption];
  };

  // Price Calculation
  const getWidthForCalculation = (width, panelType) => {
    let widthInt = parseInt(width);
    if (panelType == "Flat") {
      if (widthInt < 51) {
        return 1;
      } else if (widthInt >= 51 && widthInt < 101) {
        return 2;
      } else if (widthInt >= 101 && widthInt < 151) {
        return 3;
      } else if (widthInt >= 151) {
        return 4;
      }
    } else {
      if (widthInt < 26) {
        return 1;
      } else if (widthInt >= 26 && widthInt < 51) {
        return 2;
      } else if (widthInt >= 51 && widthInt < 76) {
        return 3;
      } else if (widthInt >= 76 && widthInt < 101) {
        return 4;
      } else if (widthInt >= 101 && widthInt < 126) {
        return 5;
      } else if (widthInt >= 126 && widthInt < 151) {
        return 6;
      } else if (widthInt >= 151 && widthInt < 176) {
        return 7;
      } else if (widthInt >= 176) {
        return 8;
      }
    }
  };

  const calculatePrice = () => {
    const liningBasePrice = $("#custom-lining-selector").attr("data-image-select-value-price");
    const headerSelected = $("#custom-header-selector").attr("data-image-select-value");
    const fabricationBasePrice = $("#custom-header-selector").attr("data-image-fabrication-cost");
    const panelType = $("#custom-header-selector").attr("data-image-panel-type");
    const widthForCalculation = getWidthForCalculation(widthValue, panelType);
    const liningOption = $("#custom-lining-selector").attr("data-image-select-value").toLowerCase();
    const weightPricePerWidth = getWeightPriceValue(liningOption);
    const pricePerYard = productMetafields.price_per_yard;
    const cusDiscountVal = productMetafields.custom_product_discount;
    const totalYards = ((16 + parseFloat(lengthValue)) / 36) * parseInt(widthForCalculation);
    const pricePerPound = 11.85;

    let priceForRuched = 0;

    if (headerSelected.toLowerCase().includes("ruched")) {
      priceForRuched = widthForCalculation * 1.5 * pricePerYard;
    }

    const fabricCost = (totalYards * pricePerYard + priceForRuched).toFixed(2);
    const liningCost = (totalYards * parseFloat(liningBasePrice)).toFixed(2);
    const fabricationCost = (widthForCalculation * parseFloat(fabricationBasePrice)).toFixed(2);
    const weightCost = parseFloat(weightPricePerWidth) * totalYards * pricePerPound;

    const extraCharge = 10;

    const total =
      parseFloat(fabricCost) + parseFloat(liningCost) + parseFloat(fabricationCost) + parseFloat(weightCost) + extraCharge;

    // Discount Value Variable (You can edit it the discount will works in percentage)
    const percentageValue = parseInt(cusDiscountVal) || 0;
    // End Comment
    
    const discountValue = total/100*percentageValue;
    const discountedTotal = total - discountValue;
    
    $(".regular-price").each(function (_, el) {
      $(el).html(`$${total.toFixed(2)}`);
    });

    $(".custom-configurator-price").each(function (_, el) {
      $(el).html(`$${discountedTotal.toFixed(2)}`);
    });

    $(".custom-configurator-price-multiple").each(function (_, el) {
      const multipleTotalVal = discountedTotal.toFixed(2);
      $(el).html(`$${(multipleTotalVal * formQuantityLabel.val()).toFixed(2)}`);
    });

    $("#custom-title-price").each(function (_, el) {
      $(el).html(`$${discountedTotal.toFixed(2)}`);
    });

    $('.custom-liningBasePrice').html(liningBasePrice);
    $('.custom-headerSelected').html(headerSelected);
    $('.custom-fabricationBasePrice').html(fabricationBasePrice);
    $('.custom-panelType').html(panelType);
    $('.custom-widthForCalculation').html(widthForCalculation);
    $('.custom-liningOption').html(liningOption);
    $('.custom-weightPricePerWidth').html(weightPricePerWidth);
    $('.custom-pricePerYard').html(pricePerYard);
    $('.custom-totalYards').html(percentageValue);

    const totalPriceModal = $('.custom-configurator-total-price');
    totalPriceModal.html(discountedTotal.toFixed(2));

    return discountedTotal;
  };

  // Setting up size selects
  const generateDataForSizes = (min, max) => {
    const arrayOfOptions = [];
    for (let i = min; i <= max; i++) {
      arrayOfOptions.push(i);
    }

    return arrayOfOptions;
  };

  const generateDataForSizesIncrement = (min, max, increment) => {
    const arrayOfOptions = [];
    for (let i = min; i <= max; i += increment) {
      arrayOfOptions.push(i);
    }

    return arrayOfOptions;
  };

  const createSelectOptions = (data, selectId) => {
    const selectElement = $(`#${selectId}`);
    selectElement.empty();
    data.forEach((option, index) => {
      let singleElement = `<option value="${option}">${option}</option>`;
      if (index == 0) {
        singleElement = `<option value="${option}" selected="selected">${option}</option>`;
      }
      selectElement.append(singleElement);
    });
  };

  // Managing the lining information
  const manageInfoForLining = () => {
    const liningSelected = $("#custom-lining-selector").attr("data-image-select-value");
    const liningInfoBoxes = $(".custom-configurator-lining-info-box");
    liningInfoBoxes.each(function (_, el) {
      $(el).hide();
      if ($(el).attr("data-image-select-item") == liningSelected) {
        $(el).show();
      }
    });
  };

  const widthOptions = generateDataForSizesIncrement(minWidth, maxWidth, 25);
  const widthOptionsForPleat = generateDataForSizes(minWidth, maxWidthForPleat);
  const lengthOptions = generateDataForSizes(minLength, maxLength);

  createSelectOptions(widthOptions, "select-width-id");
  createSelectOptions(lengthOptions, "select-length-id");

  // Size Selects config
  widthSelect.change(function () {
    widthValue = widthSelect.val();
  });

  lengthSelect.change(function () {
    lengthValue = lengthSelect.val();
  });

  // Size selectors
  const selectElements = $(".option-selector");
  const sizeValueText = $("#custom-configurator-option-title-value-size");
  const widthValueText = $('.custom-configurator-width');
  const heightValueText = $('.custom-configurator--height');

  selectElements.each((_, element) => {
    if (_ == 0) {
      widthValue = $("#select-width-id").val();
      lengthValue = $("#select-length-id").val();
      sizeValueText.html(`${widthValue}" W X ${lengthValue}" L`);
      widthValueText.html(`${widthValue}" W`);
      heightValueText.html(`${lengthValue}" L`);
    }
    $(element).change(() => {
      widthValue = $("#select-width-id").val();
      lengthValue = $("#select-length-id").val();
      sizeValueText.html(`${widthValue}" W X ${lengthValue}" L`);
      calculatePrice();
      widthValueText.html(`${widthValue}" W`);
      heightValueText.html(`${lengthValue}" L`);
    });
  });

  // Setting up slider
  $(document).ready(function () {});

  // Image selectors
  const imageSelectorElements = $(".custom-configurator-image-select");

  imageSelectorElements.each(function (_, imgSelectorEl) {
    const imageSelectsItems = $(imgSelectorEl).children(".custom-configurator-image-select-item");
    imageSelectsItems.each(function (__, imgSelectorItemEl) {
      $(imgSelectorItemEl).click(function () {
        imageSelectsItems.each(function (___, el) {
          $(el).removeClass("custom-configurator-image-select-item-active");
        });
        $(this).addClass("custom-configurator-image-select-item-active");
        const valueSelected = $(this).attr("data-image-select-item");
        const priceSelected = $(this).attr("data-image-select-item-price");
        const panelType = $(this).attr("data-image-panel-type");
        const fabricationCost = $(this).attr("data-image-fabrication-cost");

        $(this).parent().attr("data-image-select-value", valueSelected);
        $(this).parent().attr("data-image-select-value-price", priceSelected);
        if (panelType != null && panelType != undefined) {
          $(this).parent().attr("data-image-panel-type", panelType);
          if (panelType == "Flat") {
            createSelectOptions(widthOptions, "select-width-id");
          } else if (panelType == "Pleat") {
            createSelectOptions(widthOptionsForPleat, "select-width-id");
          }
          widthValue = minWidth;
          $(this).parent().attr("data-image-fabrication-cost", fabricationCost);
        }

        $(this).parent().prev().children(".custom-configurator-option-title-value").html(valueSelected);
        calculatePrice();
        manageInfoForLining();
        updateOrderSummary();
      });
    });
  });

  const updateOrderSummary = () => {
    const headerSelected = $("#custom-header-selector").attr("data-image-select-value");
    const liningSelected = $("#custom-lining-selector").attr("data-image-select-value");
    
    const headerValueText = $('.custom-configurator-header');
    const liningValueText = $('.custom-configurator-lining');

    headerValueText.html(headerSelected);
    liningValueText.html(liningSelected);
  }

  manageAvailability();
  manageInfoForLining();

  // SINGLE/DOUBLE PANELS SELECTOR
  const toggleTwoPanels = $("#custom-toggle-two-panels-btn");
  const toggleSinglePanel = $("#custom-toggle-single-panel-btn");

  const twoPanel = $("#custom-toggle-two-panels-price");
  const singlePanel = $("#custom-toggle-single-panel-price");

  const formQuantityLabel = $("input[data-quantity-field-custom]");
  const formQuantityInput = $("input[data-quantity-custom]");
  const toggleLabel = $("#toggle-quantity-label");

  toggleTwoPanels.click(function () {
    selectMultiplePanels();
  });

  toggleSinglePanel.click(function () {
    selectSinglePanel();
  });

  const selectMultiplePanels = () => {
    toggleSinglePanel.removeClass("is-selected");
    toggleTwoPanels.addClass("is-selected");
    updateQuantity();
  };

  const selectSinglePanel = () => {
    toggleTwoPanels.removeClass("is-selected");
    toggleSinglePanel.addClass("is-selected");
    updateQuantity();
    resetQuantity();
  };

  selectMultiplePanels();

  function updateQuantity() {
    const currentQuantity = parseFloat(formQuantityLabel.val());
    formQuantityLabel.val(currentQuantity);
    let quantityValueModal = $('.custom-configurator-qty');
    $("[data-current-quantity-custom]").text(currentQuantity);
    toggleLabel.text(currentQuantity);
    quantityValueModal.html(currentQuantity);
  }

  function resetQuantity() {
    formQuantityLabel.val(1);
    toggleLabel.text(1);
  }

  // QUANTITY CONTROLLER
  const quantityInput = $("#custom-configurator-qty-value");
  const quantityAddError = ("#custom-configurator-qty-btn-increase-error");
  const quantityAdd = $("#custom-configurator-qty-btn-increase");
  const quantityReduce = $("#custom-configurator-qty-btn-reduce");
  const quantityOptionPlus = $("[data-configurator-qty-option-plus]");
  let quantityValueModal = $('.custom-configurator-qty');

  quantityOptionPlus.click(function () {
    $("#custom-configurator-qty-popout").addClass("popout-container--alt");
  });

  let currentValue = parseInt(quantityInput.val());

  quantityInput.change(function () {
    const quantityValue = parseInt($(this).val());
    const maxQuantityValue = parseInt($(this).attr('max'));
    
    if (quantityValue < 1) {
      $(this).val(1);
    } else if (quantityValue > maxQuantityValue) {
      $(this).val(maxQuantityValue);
      $(quantityAddError).addClass('is-visible');
    } else {
      $(quantityAddError).removeClass('is-visible'); 
    }
    currentValue = parseInt(quantityInput.val());
    quantityValueModal.html(currentValue);
    updateSubtotal(currentValue);
  });

  const updateSubtotal = (qty) => {
    const singlePrice = parseFloat($('.custom-configurator-single-price').html().replace('$', ''));
    let quantityValueModal = $('.custom-configurator-qty');
    quantityValueModal.html(qty);
    const totalPrice = singlePrice * qty;
    $('.custom-configurator-price-subtotal').html(`$${totalPrice.toFixed(2)}`);
    $('.custom-configurator-total-price').html(`$${totalPrice.toFixed(2)}`);
  };

  quantityAdd.click(function () {
    currentValue++;
    quantityInput.val(currentValue);
    quantityInput.change();
  });

  quantityReduce.click(function () {
    currentValue--;
    quantityInput.val(currentValue);
    quantityInput.change();
  });

  formQuantityLabel.change(function () {
    const quantityValue = $(this).val();
    if (quantityValue < 1) {
      $(this).val(1);
    }

    updateQuantity();
    selectMultiplePanels();
    calculatePrice();
  });

  function updatePairPrice(panel, price) {
    const twoPanelPrice = price.toFixed(2);
    panel.html(`$${twoPanelPrice}`);
  }

  // ADD TO CART
  const customConfiguratorAddToCart = $("#custom-configurator-submit");
  customConfiguratorAddToCart.click(function () {
    let customSKU = fullData.variants.filter((variant) => variant.title === "Default Title");
    
    console.log(customSKU);

    if (customSKU.length !== 0) {
      customSKU = customSKU[0].sku;
    }

    customConfiguratorAddToCart.addClass("is-loading");
    const title = fullData.title;
    const productImage = fullData.featured_image;
    const qty = parseFloat(formQuantityLabel.val());
    const sku = customSKU;

    generateProductAndAddToCart(title, qty, `http:${productImage}`, sku);
    closeModal();
  });

  const generateProductAndAddToCart = async (title, quantity, image, sku) => {
    let price = calculatePrice();
    let productInfo = {
      title: title,
      price: price,
      quantity: quantity,
      image: image,
      sku: sku,
    };

    const res = await $.post(`${apiEndpoint}/configurator/add-custom-product`, JSON.stringify(productInfo)).promise();

    let properties = {};

    console.log('res: ', res);

    $(".custom-configurator-image-select").each(function (_, el) {
      let elName = $(el).attr("data-image-select-name");
      let elValue = $(el).attr("data-image-select-value");
      properties[elName] = elValue;
    });

    properties["Size"] = `${widthValue}" W X ${lengthValue}" L`;
    properties["Length"] = lengthValue;
    properties["Width"] = widthValue;

    let formData = {
      items: [
        {
          id: res.product.variants[0].id,
          quantity: parseInt(quantity),
          properties,
        },
      ],
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        initCartEvent();
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const initCartEvent = () => {
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:cart:init", {
        bubbles: true,
        detail: {
          button: customConfiguratorAddToCart,
        },
      })
    );
  };

  calculatePrice();

  const setCustomMode = $("#toggle-custom-mode-btn");
  const setDefaultMode = $("#toggle-default-mode-btn");

  const defaultTitlePrice = $("#default-title-price");
  const defaultOptions = $("#default-options-section");
  const defaultHeaderSelection = $("#default-header-selection");
  const defaultOrderSummary = $("#default-order-summary");
  const defaultAddToCart = $("#default-add-to-cart");

  const customTitlePrice = $("#custom-title-price");
  const customConfiguratorComponent = $("#custom-configurator-component");

  const hemmingWrapper = $(".selected--hemming--wrapper");

  const configuratorSubmit = $('#custom-configurator-submit');

  setCustomMode.click(function () {
    setDefaultMode.removeClass("is-active");
    defaultOptions.hide();
    defaultHeaderSelection.hide();
    defaultOrderSummary.hide();
    defaultAddToCart.hide();
    defaultTitlePrice.hide();
    hemmingWrapper.hide();

    setCustomMode.addClass("is-active");
    customConfiguratorComponent.show();
    customTitlePrice.show();

    // window.scrollTo(0, 0);
  });

  setDefaultMode.click(function () {
    setCustomMode.removeClass("is-active");
    customConfiguratorComponent.hide();
    customTitlePrice.hide();

    setDefaultMode.addClass("is-active");
    defaultOptions.show();
    defaultHeaderSelection.show();
    defaultOrderSummary.show();
    defaultAddToCart.show();
    defaultTitlePrice.show();
  });

  $('input[type="checkbox"]').change(function () {
    if (this.checked) {
      configuratorSubmit.removeClass('variant--unavailable');
      configuratorSubmit.prop("disabled", false);

    } else {
      configuratorSubmit.addClass('variant--unavailable');
      configuratorSubmit.prop("disabled", true);
    }
  });

  const closeModal = () => {
    setTimeout(() => {
      $('.product-modal').css({
        'opacity': '0',
        'display': 'none'
      });
    }, 3000);
  };
})();